import { render, staticRenderFns } from "./CuponesTab.vue?vue&type=template&id=2eb7a100&scoped=true&lang=pug&"
import script from "./CuponesTab.vue?vue&type=script&lang=js&"
export * from "./CuponesTab.vue?vue&type=script&lang=js&"
import style0 from "./CuponesTab.vue?vue&type=style&index=0&id=2eb7a100&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eb7a100",
  null
  
)

export default component.exports